module.exports = __webpack_public_path__ + "img/img_level_6.e7bddfd1.png";